
<template>
    <div>
        <vue-good-table id="ledesFoldersTable" ref="ledesFoldersTable" :columns="columns" :rows="rows" :sort-options="{ enabled: false}" 
            styleClass="vgt-table condensed tableSize"  :select-options="{ enabled: false, selectOnCheckboxOnly: true, selectionInfoClass: 'custom-class', selectionText: 'rows selected',
            clearSelectionText: 'clear', disableSelectInfo: true,selectAllByGroup: true }" :pagination-options="{ enabled: true, perPage: pageLength }" theme="my-theme">
            <div slot="emptystate">
                {{ $t('dataTable.data_not_found') }}
            </div>
            <!-- Column: Table Column -->
            <template slot="table-column" slot-scope="props">
                <span v-if="props.column.field === 'invoice_no'" class="text-nowrap">
                    {{ $t('ledesFolders.invoice_no') }}
                  </span>
                  <span v-else-if="props.column.field === 'clientAccountingNo'" class="text-nowrap">
                    {{ $t('ledesFolders.accounting_no') }}
                  </span>
                  <span v-else-if="props.column.field === 'updateDate'" class="text-nowrap">
                    {{ $t('ledesFolders.organizing_date') }}
                  </span>
                  <span v-else-if="props.column.field === 'recordDate'" class="text-nowrap">
                    {{ $t('ledesFolders.registration_date') }}
                  </span>
                  <span v-else-if="props.column.field === 'employee'" class="text-nowrap">
                    {{ $t('ledesFolders.user') }}
                  </span>
                  <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                    {{ $t('others.process') }}
                  </span>
            </template>   
            <!-- Column: Table Column -->
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'process'">
                    <span>
                        <b-button v-b-tooltip.html :title="$t('others.download')" variant="outline-primary" class="btn-icon mb-1 ml-1" size="sm" @click="downloadLedes(props.row.id)">
                            <feather-icon icon="DownloadIcon" />
                        </b-button>
                    </span>
                </span>
            </template>      
            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}
                        </span>
                    </div>
                    <div>
                        <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getLedesFoldersList()">
                            <template #prev-text>
                                <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                                <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                        </b-pagination>
                    </div>
                </div>
            </template>
        </vue-good-table>
    </div>
</template>
<script>
export default{
  props: {
    clientId: Number
  },
  data(){    
    return {
        id: 0,
        rows: [],
        total: 0,
        pageLength: 10,
        pageNo: 1,
        columns: [
            {
                label: this.$t('ledesFolders.invoice_no'),
                field: `invoiceNo`,
            },
            {
                label: this.$t('ledesFolders.accounting_no'),
                field: `clientAccountingNo`,
            },
            {
                label: this.$t('ledesFolders.organizing_date'),
                field: `updateDate`,
                formatFn: this.$formatFn,
            },
            {
                label: this.$t('ledesFolders.registration_date'),
                field: `recordDate`,
                formatFn: this.$formatFn,
            },
            {
                label: this.$t('ledesFolders.user'),
                field: `employee`,
            },
            {
                label: 'Process',
                field: 'process',
                width: '15em'
            },
        ],
    }
  },
  mounted() {
      this.getLedesFoldersList()
},
  methods:{
    downloadLedes(id){
        const data = { id: id }
        const controller = { name: 'ClientAccountingLedes', actionName: 'DownloadClientAccountingLedesFile'}
        const payload = { data: data, controller: controller}
        let loader = this.$loading.show()
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
            if (response.data.resultStatus == true) {
                this.$downloadFile(response.data.fileName.split('.').shift(), response.data.fileAsBase64, 'txt')
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
            loader.hide() 
        })   
    },
    getLedesFoldersList() {       
        const data = {id: this.clientId}
        const controller = { name: 'ClientAccountingLedes', actionName: 'GetClientAccountingLedesListByClientId' }
        const payload = { data: data, controller: controller }
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
        if (response.data.resultStatus == true) {
            if(response.data.clientAccountingLedesList != null){
                this.rows = response.data.clientAccountingLedesList
            }
          }
          else {
            this.$WarningAlert(response.data.resultMessage)
          }
        }
        )
      },
    }
}
</script>
<style>
.tab-content > .active {
  display: block;
  width: 75em;
}
</style>